<template>
  <div
    v-if="darkSide"
    class="footer-dark hidden sm:flex"
  >
    <div class="flex items-center flex-1 justify-between lg:justify-start">
      <div class="border border-blue p-2 mr-8">03</div>
      <div class="border border-blue p-2 mr-8 whitespace-no-wrap">345.38382 - {PEID} - 3832 - 0003</div>
      <div class="mr-8">9029348</div>
      <div>///////////////////////////</div>
    </div>
    <div class="items-center hidden lg:flex">
      <div class="mr-8">///////////////////////////</div>
      <div class="mr-8 whitespace-no-wrap">345.38382 - {PEID} - 3832 - 0003</div>
      <div>///////////////////////////</div>
    </div>
  </div>
  <div
    v-else
    class="footer"
  >
    <FooterItem
      class="footer-text"
      line1="[3882-0] 4032112"
      line2="[24-567] 345605"
    />
    <FooterItem
      class="footer-text"
      line1="///PTK PLC ERROR. RESTART SERVER…"
    />
    <FooterItem
      class="footer-text"
      line1="PROG KIT 56-0948-8872643"
      line2="345.38382 - {PEID} - 3832"
    />
    <FooterItem
      line1="CLEAN WATER ST."
      line2="3899-34-2823"
      featured
    >
      <img
        src="../../assets/percentage_example.png"
        width="50"
      >
    </FooterItem>
    <FooterItem
      line1="INT TEMP LEVELS"
      line2="72643"
      featured
    >
      <img
        src="../../assets/percentage_example.png"
        width="50"
      >
    </FooterItem>
    <FooterItem
      line1="G. HUMIDITY LVL"
      line2="56-0948-8872643"
      featured
    >
      <img
        src="../../assets/percentage_example.png"
        width="50"
      >
    </FooterItem>
    <FooterItem
      line1="S. BATTERY LVLS"
      line2="48-8872643"
      featured
    >
      <img
        src="../../assets/percentage_example.png"
        width="50"
      >
    </FooterItem>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FooterItem from './FooterItem'

export default {
  name: 'TheFooter',

  components: { FooterItem },

  computed: {
    ...mapState({
      darkSide: state => state.auth.dark,
    }),
  },
}
</script>
<style lang="postcss" scoped>
.footer {
  height: 74px;
  @apply bg-blue-darkest border-t-2 border-blue px-8 py-2 hidden;

  &-text {
    @apply hidden;
  }

  &-dark {
    height: 57px;
    font-size: 12px;
    font-family: 'input-mono';
    @apply bg-dark-black border border-blue text-blue items-center justify-between px-8;
  }
}

@screen sm {
  .footer {
    @apply flex justify-between;
  }
}

@screen xl {
  .footer {
    &-text {
      @apply block;
    }
  }
}
</style>
